// import React from "react";
// import BannerSectionStyle9 from "../Section/BannerSection/BannerSectionStyle9";
// import Section from "../Section";
// import BlogSectionStyle2 from "../Section/BlogSection/BlogSectionStyle2";
// import Breadcrumb from "../Breadcrumb";
// import { pageTitle } from "../../helpers/PageTitle";
// import { Helmet } from "react-helmet";
// const blogData = [
//   {
//     title:
//       "The Importance of Mental Health: Understanding and Managing Anxiety Disorders",
//     thumbUrl: "images/blog/post_1.jpeg",
//     date: "March 12",
//     btnText: "Learn More",
//     href: "/blog/blog-details",
//     socialShare: true,
//   },
//   {
//     title: `A Parent's Guide to Childhood Vaccinations: What You Need to Know`,
//     thumbUrl: "images/blog/post_2.jpeg",
//     date: "March 11",
//     btnText: "Learn More",
//     href: "/blog/blog-details",
//     socialShare: true,
//   },
//   {
//     title: "Preventing Heart Disease: Tips for a Heart-Healthy Lifestyle",
//     thumbUrl: "images/blog/post_3.jpeg",
//     date: "March 9",
//     btnText: "Learn More",
//     href: "/blog/blog-details",
//     socialShare: true,
//   },
//   {
//     title: "Managing Chronic Pain: Treatment Options and Strategies",
//     thumbUrl: "images/blog/post_4.jpeg",
//     date: "March 8",
//     btnText: "Learn More",
//     href: "/blog/blog-details",
//     socialShare: true,
//   },
//   {
//     title: "Understanding and Managing Diabetes: Tips for Healthy Living",
//     thumbUrl: "images/blog/post_5.jpeg",
//     date: "March 5",
//     btnText: "Learn More",
//     href: "/blog/blog-details",
//     socialShare: true,
//   },
//   {
//     title: "The Role of Physical Therapy in Injury Recovery and Prevention",
//     thumbUrl: "images/blog/post_6.jpeg",
//     date: "March 2",
//     btnText: "Learn More",
//     href: "/blog/blog-details",
//     socialShare: true,
//   },
//   {
//     title: "Breaking the Stigma: Raising Awareness for Mental Health Issues",
//     thumbUrl: "images/blog/post_7.jpeg",
//     date: "Feb 28",
//     btnText: "Learn More",
//     href: "/blog/blog-details",
//     socialShare: true,
//   },
//   {
//     title: "Allergies and Asthma: Causes, Symptoms, and Treatment Options",
//     thumbUrl: "images/blog/post_8.jpeg",
//     date: "Feb 26",
//     btnText: "Learn More",
//     href: "/blog/blog-details",
//     socialShare: true,
//   },
//   {
//     title: "Caring for Your Skin: Tips for Healthy, Glowing Skin",
//     thumbUrl: "images/blog/post_9.jpeg",
//     date: "Feb 25",
//     btnText: "Learn More",
//     href: "/blog/blog-details",
//     socialShare: true,
//   },
// ];

// export default function Blog() {
//   return (
//     <>
//       <Helmet>
//         <title>Blog about Hyper-Hypothermia Unit | Mercury Healthcare</title>
//         <meta
//           name="description"
//           content="Mercury Healthcare blog where you can read article about Hyper-Hypothermia Unit, Medical Unit and Many more."
//         />
//         <meta
//           name="Keyword"
//           content="Hyper-Hypothermia Machine Manufacture In India, Heater Cooler Machine in India, Fast Cooling machine in India, Perfusion system in India, Cardiac Surgery Machine in India,"
//         />
//       </Helmet>
//       {/* <Section topMd={170} bottomMd={96} bottomLg={70}>
//         <Breadcrumb title="Psychology and Life Style" />
//         <iframe
//           src="https://mercuryhc.com/blogs/"
//           frameborder="0"
//           height={1200}
//           title="Mercury"
//           width={1400}
//         ></iframe>
//       </Section> */}
//     </>
//   );
// }
import React from 'react';
import BannerSectionStyle9 from '../Section/BannerSection/BannerSectionStyle9';
import Section from '../Section';
import BlogSectionStyle2 from '../Section/BlogSection/BlogSectionStyle2';
import Breadcrumb from '../Breadcrumb';
import { pageTitle } from '../../helpers/PageTitle';

const blogData = [
  {
    id: 1,
    title: 'What is hyper-hypothermia unit?',
    thumbUrl: 'images/blog/hyper-hypothermia.jpg',
    date: '3/2/2024',
    btnText: 'Read More',
    href: '/blog/What-is-hyper-hypothermia-unit',
    socialShare: true,
  },
  {
    id: 2,
    title: 'The Evolution of ECMO Care: How Mercury Healthcare Is Redefining Portable Heater Units.',
    thumbUrl: 'images/blog/How Mercury Healthcare Is Redefining Portable Heater Units.jpg',
    date: '16/5/2024',
    btnText: 'Read More',
    href: '/blog/evolution-of-ecmo-care-mercury-healthcare-portable-heater-units',
    socialShare: true,
  },
  {
    id: 3,
    title: 'Choosing the Right Sternum Saw: Key Features and Best Practices for Surgeons',
    thumbUrl: 'images/blog/Choosing the Right Sternum Saw- Key Features and Best Practices for Surgeons.jpg',
    date: '26/5/2024',
    btnText: 'Read More',
    href: '/blog/choosing-the-right-sternum-saw-key-features-and-best-practices-for-surgeons',
    socialShare: true,
  },
  {
    id: 4,
    title: 'The Role of Hyper-Hypothermia Machines in Modern Surgery: Mercury HC',
    thumbUrl: 'images/blog/The Role of Hyper-Hypothermia Machines in Modern Surgery.jpg',
    date: '26/5/2024',
    btnText: 'Read More',
    href: '/blog/the-role-of-hyper-hypothermia-machines-in-modern-surgery-mercury-hc',
    socialShare: true,
  },
  {
    id: 5,
    title: 'Mercury Micro: Trusted ECMO Heater by India’s Leading Manufacturer & Supplier – Mercury Healthcare',
    thumbUrl: 'images/blog/Mercury Micro – Mercury Healthcare.jpg',
    date: '26/5/2024',
    btnText: 'Read More',
    href: '/blog/mercury-micro-ecmo-heater-by-india’s-leading-manufacturer-supplier-mercury-hc',
    socialShare: true,
  },

  {
    id: 6,
    title: 'Behind the Scenes in the OR: How Sternum Saws Help Surgeons Save Lives Daily',
    thumbUrl: 'images/blog/How Sternum Saws Help Surgeons Save Lives Daily.jpg',
    date: '26/6/2025',
    btnText: 'Read More',
    href: '/blog/behind-the-scenes-in-the-or-how-sternum-saws-help-surgeons-save-lives-daily',
    socialShare: true,
  },

  {
    id: 7,
    title: 'Safety and Training: What Healthcare Professionals Need to Know About Hyper-Hypothermia Machines ',
    thumbUrl: 'images/blog/Hyper-Hypothermia Units 1.jpg',
    date: '26/7/2025',
    btnText: 'Read More',
    href: '/blog/safety-and-training-what-healthcare-professionals-need-to-know-about-hyper-hypothermia-machines',
    socialShare: true,
  },

  {
    id: 8,
    title: 'Hyper-Hypothermia Machines: Applications in Trauma and Postoperative Recovery ',
    thumbUrl: 'images/blog/Hyper-Hypothermia Machines Thumbnail.jpg',
    date: '25/8/2025',
    btnText: 'Read More',
    href: '/blog/hyper-hypothermia-machines-applications-in-trauma-and-postoperative-recovery',
    socialShare: true,
  },
];

export default function Blog() {
  pageTitle('Blog');

  return (
    <>
      <Section topMd={170} bottomMd={96} bottomLg={70}>
        <Breadcrumb title="Blogs" />
      </Section>
      <Section bottomMd={200} bottomLg={150} bottomXl={110}>
        <BlogSectionStyle2 data={blogData} />
      </Section>
      {/* Uncomment below if banner is needed */}
      {/*
      <Section className="cs_footer_margin_0">
        <BannerSectionStyle9
          title="Don’t Let Your Health <br />Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced <br />medical professionals today!"
          imgUrl="/images/doctors/banner_img_3.png"
        />
      </Section>
      */}
    </>
  );
}
